$(document).ready(function () {
    $(".ImageSlider").owlCarousel({
        nav: false,
        dots: false,
        loop: true,
        autoplay: true,
        slideSpeed: 2000,
        margin: 0,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            470: {
                items: 1,
            },
            1200: {
                items: 1,
            },
        },
    });
    $(".BrandCarousel").owlCarousel({
        nav: false,
        dots: true,
        loop: false,
        autoplay: true,
        slideSpeed: 2000,
        margin: 20,
        responsiveClass: true,

        responsive: {
            0: {
                items: 1,
            },
            470: {
                items: 2,
            },
            1200: {
                items: 5,
            }
        },
    });
    $(".CollectionCarousel").owlCarousel({
        nav: false,
        dots: true,
        loop: false,
        autoplay: true,
        slideSpeed: 2000,
        margin: 20,
        responsiveClass: true,

        responsive: {
            0: {
                items: 1,
            },
            470: {
                items: 2,
            },
            1200: {
                items: 3,
            }
        },
    });
    $('.close-menu').on('click', function () {
        $('.mobile-navigation').removeClass('expand')
    });
    $('.menu-btn').on('click', function () {
        $('.mobile-navigation').addClass('expand')
    });
    $('.menu-item-has-children > i').on('click', function () {
        $(this).next('ul.sub-menu').slideToggle();
    });
});